export const apiKey = "2399ca9006b68e5acde554285171fb7a";
export const apiToken = "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyMzk5Y2E5MDA2YjY4ZTVhY2RlNTU0Mjg1MTcxZmI3YSIsInN1YiI6IjYzMWIzMTQ1NzdiMWZiMDA4NWFjMmRhNSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.aMtz8_QHH3C8rLssjhwS_UulnVdR4-JSWpazUWi0yhg"
